<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: ImageLibrary - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal" id="image_library">
    <upload-image-view @getdata="getdata" :upload="upload" @closeUpload="closeUpload" />
    <div class="mt-6 flex items-center justify-between px-6" >
        <span class="flex items-center justify-center">
        <h4>Image Library</h4>
        <vs-button class="ml-4"  @click.native="upload=true"  size="small" icon-pack="feather" icon="icon-upload" >Upload</vs-button>
        </span>
        <vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="search" class="is-label-placeholder mt-0 mb-0" />

        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
<vs-row vs-w="12" v-if="bredCrumShow">
  <vs-col  vs-justify="flex-start" vs-align="center" vs-w="12">
    <span class="flex" v-if="activebredcrum">
    <h1 class="inline-flex">{{activebredcrum}}</h1>
    <feather-icon icon="StarIcon" :svgClasses="['stoke-current text-warning']" class="cursor-pointer ml-2 inline-flex"  />
    </span>
    <vs-breadcrumb>
   <li class="flex">
     <p @click="getMain()" class="cursor-pointer ">Folders</p><span class="vs-breadcrum--separator">/</span></li>
   <li>
   <li v-for="bred in bredcrums" :key="bred.id" class="flex cursor-pointer ">
     <p @click="SetFolderImg(bred.id)">{{bred.name}}{{bred.id}}</p><span class="vs-breadcrum--separator">/</span>
   </li>
   <li aria-current="page" class="active">{{activebredcrum}}</li>
</vs-breadcrumb>
  </vs-col>
</vs-row>
        <!-- <template v-if="dataImg">

          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataImg" alt="img" class="responsive">
          </div>

          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Update Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataImg = null">Remove Image</vs-button>
          </div>
        </template> -->
          <vs-tooltip :text="folder.name"  v-for="folder in folders" :key="folder.id" class="cursor-pointer m-1 inline-flex" >
          <img src="@/assets/images/pages/folder.svg" :alt="folder.name" style="height: 115px !important; width: 115px !important; object-fit: cover !important;" class="sidebar_img_border" @click="SetFolderImg(folder.id)">
          </vs-tooltip>
            <span v-for="img in images" :key=img.id class="cursor-pointer" >
            <img :src="img.url" alt="" style="height: 115px !important; width: 115px !important; object-fit: cover !important;" class="sidebar_img_border" @click="addImg(img.url)">
            </span>
        </div>
    </component>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import {GET_IMAGE_LIBARY,GET_FOLDER,GET_FOLDER_WITH_IMAGES,
GET_FOLDER_IMAGE,
GET_FOLDER_SUBFOLDER,
GET_DIRECTORY_BREDCRUM
} from '@/graphql'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  components: {
    VuePerfectScrollbar,
    UploadImageView: () => import('../images/components/UploadImageView'),

  },
  data () {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      images:[],
      orignal_images:[],
      folders:[],
      orignal_folders:[],
      orignal_folderImages:[],
      upload:false,
      search:null,
      bredcrums:[],
      bredCrumShow:false

    }
  },
  watch: {
    isSidebarActive (val) {
    //  if(val && this.images.length==0){
    //      this.get();
    //  }
    },
        search: function (val) {
       if(val){
        this.images = this.orignal_images.filter(img => {
        return img.name.toLowerCase().includes(val.toLowerCase())
        })
        this.folders = this.orignal_folders.filter(folder => {
        return folder.name.toLowerCase().includes(val.toLowerCase())
        })
      }
      else{
        this.images=this.orignal_images
        this.folders=this.orignal_folders
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
  activebredcrum(){
      let bredcrums = this.bredcrums
      if(bredcrums.length>0){
        let active = bredcrums[bredcrums.length -1].name
        bredcrums.pop();
        return active
      }
    },
    isFormValid () {
      return !this.errors.any() 
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    getMain(){
      this.bredCrumShow=false
      this.getFolder()
      this.get()
    },
    SetFolderImg(id){
    this.getFolderImage(id)
    this.getSubFolder(id)
    this.getBredcrum(id)
    },
    closeUpload(val){
    this.upload=val
}, 
    getFolderImage(id){
        this.$apollo
        .mutate({
          mutation: GET_FOLDER_IMAGE,
          variables: {
                id: id
          }
        })
        .then(response => {
             this.images=response.data.getFolderImages
            this.orignal_images=this.images
        }
        )
    },
     getSubFolder(id){
        this.$apollo
        .mutate({
          mutation: GET_FOLDER_SUBFOLDER,
          variables: {
                id: id
          }
        })
        .then(response => {
             this.folders=response.data.getFolderSubfolder
            this.orignal_folders=this.folders
        }
        )
    },
    getBredcrum(id){
        this.$apollo
        .mutate({
          mutation: GET_DIRECTORY_BREDCRUM,
          variables: {
                id: id
          }
        })
        .then(response => {
             this.bredcrums=response.data.getDirectoryBredcrum
             this.bredCrumShow=true
        }
        )
    },
  getdata (value) {
    if(value==='image'){
        this.get()
    }else{
      this.getFolder()
    }
  },
      addImg(url){
        this.$emit('setImg',url)
        this.$emit('closeSidebar')
      },
      get(){
      this.$apollo
      .mutate({
        mutation: GET_IMAGE_LIBARY
      })
      .then(response => {
      this.images=response.data.getImageLibrary
      for (let index = 0; index < this.images.length; index++) {
        this.images[index].check=false;
      }
      this.orignal_images=this.images
    }).catch(error => {
      console.log(error)
    })
    },
   getFolder(){
      this.$apollo
      .mutate({
        mutation: GET_FOLDER
      })
    .then(response => {
      if(response.data.getFolder.status==='Success'){
      this.folders=response.data.getFolder.folder
      this.orignal_folders=this.folders
      }
    }).catch(error => {
      console.log(error)
    })
    }, 
    StatusSuccess () {
      this.$vs.notify({
        title: 'Newsletter',
        text: 'Add successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFail () {
      this.$vs.notify({
        title: 'Newsletter',
        text: 'Failed to add',
        color: 'success',
        position: 'top-right'
      })
    },
  },
  created(){
      this.getMain()
  } 
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 1000px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
.ownsidebar{
    width:100px !important;
    max-width:257px !important;
}
</style>
<style>
.vs-tooltip{
  z-index: 99999 ;
}
</style>
